import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=3849674a"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"
import style0 from "./Awards.vue?vue&type=style&index=0&id=3849674a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports